import React, { useState } from 'react';
import logo from '../assets/images/logo.svg';

function Head() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="main-header header-three text-white">
            <div className="header-upper">
                <div className="container-fluid clearfix">
                    <div className="header-inner d-flex align-items-center">
                        <div className="logo-outer">
                            <div className="logo">
                                <a href="#">
                                    <img className="logoIndian" src={logo} alt="Logo" />
                                </a>
                            </div>
                        </div>

                        <div className="nav-outer clearfix d-flex align-items-center">
                            <nav className="main-menu navbar-expand-lg">
                                <div className="navbar-header">
                                    <div className="mobile-logo">
                                        <a href="#">
                                            <img src={logo} alt="Logo" title="Logo" />
                                        </a>
                                    </div>

                                    <div
                                        type="button"
                                        className="navbar-toggle"
                                        onClick={toggleMenu}
                                    >
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </div>
                                </div>

                                <div className={`navbar-collapse collapse ${isMenuOpen ? 'show' : ''}`}>
                                    <ul className="navigation clearfix">
                                        <li className="current dropdown">
                                            <a href="#">Home</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#about">About Us</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#services">Service</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#KYC">KYC Form</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#numberChange">Mobile Number Change</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#tvrvLoss">TCRV Loss</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#areachange">Area Change</a>
                                        </li>
                                        <li className="dropdown">
                                            <a href="#gallery">Gallery</a>
                                        </li>

                                        <li><a href="#contact">Contact</a></li>
                                    </ul>
                                </div>
                            </nav>

                            <div className="menu-btn">
                                <a href="#contact" className="theme-btn text-align: center;">Reach Out</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Head;
